export default {

  /**
   * @param state
   * @returns {this|Array}
   */
  getParticipantsWithFullName(state) {
    const stateParticipants = state.participants.items;
    if (!stateParticipants || !Object.keys(stateParticipants).length) {
      return [];
    }
    const participantsWithFullName = stateParticipants.map((stateParticipant) => {
      const fullName = stateParticipant.firstName.concat(' ')
        .concat(stateParticipant.lastName);
      let ageDescription = 'missing birthday';
      if (stateParticipant.birthday) {
        if (stateParticipant.validBirthday) {
          ageDescription = stateParticipant.birthday.concat(', ')
            .concat(stateParticipant.age)
            .concat(' years');
        } else {
          ageDescription = `${stateParticipant.age} years, birthday not verified`;
        }
      }

      return {
        id: stateParticipant.id,
        bookingStayId: stateParticipant.bookingStayId,
        fullName: fullName
          .concat(' (')
          .concat(ageDescription)
          .concat(')'),
        firstName: stateParticipant.firstName,
        lastName: stateParticipant.lastName,
        birthday: stateParticipant.birthday,
        validBirthday: stateParticipant.validBirthday,
        age: stateParticipant.age,
        areaId: stateParticipant.areaId,
      };
    });

    return participantsWithFullName.sort((a, b) => a.firstName.localeCompare(b.firstName));
  },

  /**
   * @param state
   * @returns {{areaId: *, id: *}[]|Array}
   */
  getBookingStays(state) {
    const stateBookingStays = state.booking.stays;
    if (!stateBookingStays || !stateBookingStays.length) {
      return [];
    }

    return stateBookingStays.map(
      stay => ({
        id: stay.id,
        bookingId: stay.bookingId,
        areaId: stay.areaId,
      }));
  },

  /**
   * @param state
   * @returns {{area: *, areaId: *, id: *, bookingId: *}[]|Array}
   */
  getBookingStaysWithArea(state) {
    const stateBookingStays = state.booking.stays;
    const stateAreas = state.areas.items;
    if (
      !stateBookingStays
      || !stateBookingStays.length
      || !stateAreas
      || !stateAreas.length
    ) {
      return [];
    }

    return stateBookingStays.map((bookingStay) => {
      const area = stateAreas.find(stateArea =>
        stateArea.id === bookingStay.areaId,
      );
      return {
        id: bookingStay.id,
        bookingId: bookingStay.bookingId,
        areaId: bookingStay.areaId,
        area,
      };
    });
  },

  /**
   * @param state
   * @returns {[]|Array}
   */
  getBookingStayAreas(state) {
    const stateBookingAreas = state.areas.items;
    if (!stateBookingAreas || !stateBookingAreas.length) {
      return [];
    }

    return stateBookingAreas;
  },

  /**
   * @param state
   * @param getters
   * @returns {[]|Array}
   */
  getAvailableDates(state, getters) {
    const stateBookingStays = state.booking.stays;
    if (!stateBookingStays || !Object.keys(stateBookingStays).length) {
      return [];
    }
    const minimumArrivalDate = getters.minimumArrivalDate(state);
    const maximumDepartureDate = new Date(
      Math.max.apply(null, stateBookingStays.map(e => new Date(e.departureDate))),
    );
    const availableDates = [];
    const dt = new Date(minimumArrivalDate);
    while (dt <= maximumDepartureDate) {
      availableDates.push(dt.toISOString().substring(0, 10));
      dt.setDate(dt.getDate() + 1);
    }

    return availableDates;
  },

  /**
   * @param state
   * @returns {*|Element|undefined}
   */
  getDefaultAreaId(state) {
    const stateAreas = state.areas.items;
    if (!stateAreas || !stateAreas.length) {
      return undefined;
    }

    return stateAreas[0].id;
  },

  /**
   * @param state
   * @param getters
   * @returns {*|Function}
   */
  getMinimumArrivalDateFromBookingStays(state, getters) {
    const dt = getters.minimumArrivalDate(state);
    return dt.toISOString().substring(0, 10);
  },

  /**
   * @returns {Function}
   */
  minimumArrivalDate: () => (state) => {
    const stateBookingStays = state.booking.stays;
    if (!stateBookingStays || !stateBookingStays.length) {
      return new Date();
    }
    return new Date(
      Math.min.apply(null, stateBookingStays.map(e => new Date(e.arrivalDate))),
    );
  },

  /**
   * @param state
   * @returns {string|undefined}
   */
  getTwentyBookingUrl(state) {
    const stateBooking = state.booking;
    if (!stateBooking || (stateBooking && !stateBooking.id)) {
      return undefined;
    }

    return `${process.env.TWENTY_FRONT_PAGE}/booking/bookings/${stateBooking.id}/info`;
  },

  /**
   * @param state
   * @returns {string|undefined}
   */
  getTwentyBookingCustomerUrl(state) {
    const stateBooking = state.booking;
    if (!stateBooking || (stateBooking && !stateBooking.id)) {
      return undefined;
    }

    return `${process.env.TWENTY_FRONT_PAGE}/booking/bookings/${stateBooking.id}/customer`;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/booking/getters.js